import config from '../config';
import {
  getProjectsList,
  getProjectsListFailed,
  deleteProjectById,
  getProjectById,
  getSalesPersons,
  getContactsList,
  getContactsListFailed
} from '../actions/projects';
import fetch from 'cross-fetch';
import store from 'store2';
import {addNotification as notify} from 'reapop';
import {push} from 'react-router-redux';
import {path} from "ramda";

export function getList() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/project`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getProjectsList({list: json}));
          }
        })
        .catch(response => dispatch(getProjectsListFailed({error: response})));
    }
  }
};

export function addNewProject(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/project`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json.detail && json.detail.error) {
            dispatch(notify({
              title: 'Add New Customer',
              message: json.detail.error,
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          } else if (json) {
            dispatch(push('/pages/customers'));
            dispatch(notify({
              title: 'Add New Customer',
              message: 'Customer added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Customer',
            message: 'Failed to add customer',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function updateProject(id, data, remove, add) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/project/${id}`, {
        method: 'PUT',
        body: JSON.stringify({data}),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          const error = path(['detail', 'error'], json);
          if(error){
            dispatch(notify({
              title: 'Update Customer',
              message: error,
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          }
          else {
            if(remove && remove.length) {
              fetchUrl(`projectSalesMap/`, 'DELETE', {remove})
            }
            if(add && add.length) {
              fetchUrl(`projectSalesMap/save/${id}`, 'POST', {appoint_to: 'customer', add})
            }
            dispatch(notify({
              title: 'Update Customer',
              message: 'Customer has been updated successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          }
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        })
        .catch(response => {
          dispatch(notify({
            title: 'Update Customer',
            message: 'Failed to update customer',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function fetchProjectById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/project/${data.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getProjectById({currentProject: json}));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Get Project',
            message: 'Failed to get project',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function getContactsByProjectId(id) {
  return (dispatch) => {
    if (!id) {
      dispatch(getContactsList({contacts: []})) ;
    } else {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`project/getContacts/${id}`)
        .then((response) => {
          return response.json()
        })
        .then(json => {
          if (json) {
            dispatch(getContactsList({contacts: json})) ;
          }
        })
        .catch(() => {
          dispatch(getContactsListFailed({contacts: []}));
        });
      }
    }
  }
}

export function getSalesPersonsList() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      fetchUrl(`projectSalesMap/getSalesPersonsList`)
        .then((response) => {
          return response.json();
        })
        .then(list => {
          if (list) {
            dispatch(getSalesPersons({salesPersonsList: list}));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Get Sales Persons',
            message: 'Failed to get sales persons',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function getProjectWithContacts(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`project/${id}`)
        .then((response) => {
          return response.json();
        })
        .then(project => {
          if (project) {
            fetchUrl(`project/getContacts/${id}`)
              .then((response) => {
                return response.json();
              })
              .then(contacts => {
                if (contacts) {
                  fetchUrl(`/projectSalesMap/${id}/customer`)
                    .then((response) => {
                      return response.json();
                    })
                    .then(salespersons => {
                      if (salespersons.title === 'Internal Error') {
                        dispatch(getProjectById({
                          currentContacts: contacts,
                          currentProject: project,
                          currentSalesPerson: []
                        }));
                      } else {
                        dispatch(getProjectById({
                          currentContacts: contacts,
                          currentProject: project,
                          currentSalesPerson: salespersons
                        }));
                      }
                    });
                }
              })
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Get Customer',
            message: 'Failed to get customer',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function removeProjectById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/project/${data.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(deleteProjectById({id: data.id}));
            dispatch(notify({
              title: 'Delete Project',
              message: 'Project deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};

const fetchUrl = (url, method = 'GET', data) => {
  return fetch(`${config.apiEndpoint}/${url}`, {
    method,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `bearer ${store.get('user').api_token}`
    },
    credentials: 'same-origin'
  })
};



// WEBPACK FOOTER //
// ./src/api/projects.js